<template>
    <div v-if="model">
        <el-form ref="form" :model="model" :rules="rules" label-width="120px" label-position="top"
                 size="mini">
            <el-form-item label="栏目名称" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
        </el-form>
        <el-form ref="configForm" :model="model.config" :rules="configRules" label-width="120px" label-position="top"
                 size="mini">
            <el-form-item label="适用上级条件" prop="inheritPageQuery">
                <el-select v-model="model.config.inheritPageQuery">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标签页设置">
                <el-button @click="addTab">添加标签页</el-button>
            </el-form-item>
        </el-form>
        <div v-for="(tab,index) in model.config.tabs" :key="index">
            <el-divider></el-divider>
            <el-form  ref="tabForm" :model="tab" :rules="tabRules"
                      label-width="120px" label-position="top" size="mini">
                <el-form-item label="标签名称" prop="name">
                    <el-input v-model="tab.name"></el-input>
                </el-form-item>
                <el-form-item label="数据源" prop="datasource">
                    <datasource-select v-model="tab.datasource"></datasource-select>
                </el-form-item>
                <el-form-item label="时间字段" prop="timeField">
                    <el-input v-model="tab.timeField"></el-input>
                </el-form-item>
                <el-form-item label="默认排序" prop="sort">
                    <el-input v-model="tab.sort"></el-input>
                </el-form-item>
                <el-form-item label="检索条件" prop="queryConfig" v-if="tab.datasource">
                    <es-query-editor v-model="tab.queryConfig" :data-source-id="tab.datasource.id"></es-query-editor>
                </el-form-item>
                <el-form-item label="首页样式" prop="indexStyle">
                    <view-style-select v-model="tab.indexStyle" :datasource-id="tab.datasource?tab.datasource.id:null"></view-style-select>
                </el-form-item>
                <el-form-item label="列表页样式" prop="listStyle">
                    <view-style-select v-model="tab.listStyle" :datasource-id="tab.datasource?tab.datasource.id:null"></view-style-select>
                </el-form-item>
                <el-form-item label="细览页样式" prop="detailsStyle">
                    <view-style-select v-model="tab.detailsStyle" :datasource-id="tab.datasource?tab.datasource.id:null"></view-style-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="deleteTab(index)">删除标签页</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import sectionService from '../../service/section'
    import DatasourceSelect from '../common/DatasourceSelect'
    import ViewStyleSelect from '../common/ViewStyleSelect'
    import EsQueryEditor from "../common/EsQueryEditor";
    import {buildQueryFromQueryConfig} from '../../service/EsQueryUtils'

    export default {
        name: "NewsSectionConfigForm",
        components: {DatasourceSelect, ViewStyleSelect, EsQueryEditor},
        props: {
            id: Number
        },
        data() {
            const checkQueryConfig = (rule, value, callback) => {
                if (value) {
                    const query = buildQueryFromQueryConfig(value)
                    if(query&&query.length>10000){
                        callback(new Error('长度不能超过 10000 个字符'))
                    }else{
                        callback()
                    }
                } else {
                    callback();
                }
            }
            return {
                dirty: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入栏目名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ]
                },
                configRules: {
                    inheritPageQuery: [
                        {required: true, message: '请输入是否适用上级条件', trigger: 'blur'},
                    ]
                },
                tabRules: {
                    name: [
                        {required: true, message: '请输入标签名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    datasource: [
                        {required: true, message: '请选择数据源', trigger: 'blur'},
                    ],
                    timeField: [
                        {required: true, message: '请输入时间字段名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    sort: [
                        {required: true, message: '请输入默认排序', trigger: 'blur'},
                        {min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur'},
                    ],
                    queryConfig: [
                        {validator: checkQueryConfig, trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
            this.init()
        },
        watch: {
            id() {
                this.init()
            },
            model: {
                handler(newValue, oldValue) {
                    // 只有model引用不变而内容发生变化时才将dirty设置为true
                    this.dirty = newValue === oldValue
                },
                deep: true
            }
        },
        methods: {
            async init() {
                const response = await sectionService.getSection(this.id)
                const model = response.data
                if (model.config) {
                    model.config = JSON.parse(model.config)
                } else {
                    model.config = {
                        inheritPageQuery: null,
                        tabs: []
                    }
                }
                if (!model.config.hasOwnProperty('inheritPageQuery')) {
                    model.config.inheritPageQuery = null
                }
                for(const tab of model.config.tabs){
                    if(!tab.queryConfig){
                        tab.queryConfig = tab.query
                    }
                }
                this.model = model
                this.dirty = false
            },
            isDirty() {
                return this.dirty
            },
            async save() {
                const validatePromises = []
                validatePromises.push(this.$refs.form.validate())
                validatePromises.push(this.$refs.configForm.validate())
                if (Array.isArray(this.$refs.tabForm)) {
                    validatePromises.push(...this.$refs.tabForm.map(form => form.validate()))
                } else if (this.$refs.tabForm) {
                    validatePromises.push(this.$refs.tabForm.validate())
                }
                await Promise.all(validatePromises)
                const data = JSON.parse(JSON.stringify(this.model))
                data.config.tabs.forEach(tab => {
                    tab.datasource = {
                        id: tab.datasource.id,
                        name: tab.datasource.name,
                        type: tab.datasource.type
                    }
                    tab.query = buildQueryFromQueryConfig(tab.queryConfig)
                })
                data.config = JSON.stringify(data.config)
                await sectionService.updateSection(data)
                this.dirty = false
            },
            addTab() {
                this.model.config.tabs.push({
                    name: null,
                    datasource: null,
                    timeField: null,
                    sort: null,
                    query: null,
                    queryConfig: null,
                    indexStyle: null,
                    listStyle: null,
                    detailsStyle: null
                })
            },
            deleteTab(index) {
                this.model.config.tabs.splice(index, 1)
            }
        }
    }
</script>

<style scoped>

</style>
